import { Component } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { RouterLink } from '@angular/router';
import { NgIf } from '@angular/common';
import { SessionComponent } from '../session/session.component';
import { UserService } from '../../services/user/user.service';
import { MatTooltipModule } from '@angular/material/tooltip';


@Component({
    selector: 'app-header',
    imports: [RouterLink, SessionComponent, MatTooltipModule],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})
export class HeaderComponent {
    public get user() {
        return this.userService.user;
    }

    checkRoles(userRoles: string[], permittedRoles: string[]) {
        return permittedRoles.some(role => userRoles.includes(role));
    }

    //
    constructor(private userService: UserService) { }
}
